// @core/api/endpoints/task/schedule_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ScheduleTaskRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Schedule task
 * Schedules work on a task by setting a time block in the assignee's calendar. Creates a CalendarAspect on the task with start/end time, timezone, and location. The assignee's calendar shows a blocked time slot for this task. Use for workforce planning and shift scheduling.
 */
export async function ScheduleTask(
  task_id: string,
  data: ScheduleTaskRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/schedule`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
